import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/IdentificationCard.es.js";
const t = o.forwardRef((a, i) => /* @__PURE__ */ o.createElement(e, { ref: i, ...a, weights: r }));
t.displayName = "IdentificationCardIcon";
const d = t;
export {
  d as IdentificationCard,
  t as IdentificationCardIcon
};
